export default {"src":"https://fishbrain.com/_next/static/media/medium.044f0397.svg","height":37,"width":46,"blurWidth":0,"blurHeight":0};